"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EducationFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _Address = _interopRequireDefault(require("../Address/Address"));

var _fields = require("../../fields");

var _educationConfig = require("./educationConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var EducationDefinition = _flowRuntime["default"].tdz(function () {
  return _educationConfig.EducationDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("component", _flowRuntime["default"].ref(EducationDefinition)), _flowRuntime["default"].property("optionValue", _flowRuntime["default"].string()), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())))));

var EducationFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(EducationFields, _React$Component);

  var _super = (0, _createSuper2["default"])(EducationFields);

  function EducationFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, EducationFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleChange = function () {
      var resetFields = _this.props.resetFields;
      resetFields();
    };

    return _this;
  }

  (0, _createClass2["default"])(EducationFields, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          optionValue = _this$props.optionValue;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fields.Radio, {
        id: _educationConfig.educationType.key,
        radio: _educationConfig.educationType,
        onChange: this.handleChange
      }), optionValue === _educationConfig.educationTypeOptions.sixthForm && /*#__PURE__*/_react["default"].createElement(_Address["default"], {
        address: _educationConfig.schoolAddress,
        parentKey: component.key
      }), optionValue === _educationConfig.educationTypeOptions.workBasedEducation && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, "Please give the name and business registration number of the organisation you are working with:"), /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        textfield: _educationConfig.workName
      }), /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        textfield: _educationConfig.workRegistrationNumber
      })), (optionValue === _educationConfig.educationTypeOptions.sixthForm || optionValue === _educationConfig.educationTypeOptions.workBasedEducation) && /*#__PURE__*/_react["default"].createElement(_fields.Date, {
        date: _educationConfig.expectedLeaveDate
      }), optionValue === _educationConfig.educationTypeOptions.other && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        textfield: _educationConfig.other
      }));
    }
  }]);
  return EducationFields;
}(_react["default"].Component);

exports.EducationFields = EducationFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    optionValue: selector(state, "".concat(componentKey, ".educationType"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var componentKey = ownProps.componentKey;
  var educationTypePath = "".concat(componentKey, ".educationType");
  var expectedLeaveDatePath = "".concat(componentKey, ".expectedLeaveDate");
  var schoolAddressPath = "".concat(componentKey, ".schoolAddress");
  var workNamePath = "".concat(componentKey, ".workName");
  var workRegistrationNumberPath = "".concat(componentKey, ".workRegistrationNumber");
  var otherPath = "".concat(componentKey, ".other");
  var fields = [educationTypePath, expectedLeaveDatePath, schoolAddressPath, workNamePath, workRegistrationNumberPath, otherPath];
  return {
    resetFields: function resetFields() {
      Promise.all([dispatch((0, _reduxForm.change)('form', educationTypePath, '')), dispatch((0, _reduxForm.change)('form', expectedLeaveDatePath, '')), dispatch((0, _reduxForm.change)('form', schoolAddressPath, '')), dispatch((0, _reduxForm.change)('form', workNamePath, '')), dispatch((0, _reduxForm.change)('form', workRegistrationNumberPath, '')), dispatch((0, _reduxForm.change)('form', otherPath, '')), dispatch(_reduxForm.untouch.apply(void 0, ['form'].concat(fields)))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EducationFields);

exports["default"] = _default;